import React, { useEffect, useMemo, useState } from "react";
import { Modal, Select, Typography, Flex, Alert, Input } from "antd";

const SUFFIX_ALLOWED = /[^A-Za-z0-9 ()_-]/g;
const sanitizeSuffix = (raw) => (raw || "").replace(SUFFIX_ALLOWED, "");

const DuplicateFormModal = ({
  open,
  form,
  sourceRole,
  roles,
  loading,
  onCancel,
  onConfirm,
}) => {
  const [targetRoleIds, setTargetRoleIds] = useState([]);
  const [nameSuffix, setNameSuffix] = useState("");

  useEffect(() => {
    if (open) {
      setTargetRoleIds([]);
      setNameSuffix(sanitizeSuffix(" (Copy)"));
    }
  }, [open, form?.id]);

  const excludeNurse = form?.mode === "OP" || form?.mode === "BOTH";

  const options = useMemo(
    () =>
      (roles || [])
        .filter((r) => r.id !== sourceRole?.id)
        .filter((r) => !(excludeNurse && r.value === "Nurse"))
        .map((r) => ({
          label: r.name + (r.system ? " (built-in)" : ""),
          value: r.id,
        })),
    [roles, sourceRole?.id, excludeNurse]
  );

  const cleanName = (form?.name || "").trim();
  const nextName = `${cleanName}${nameSuffix || ""}`.trim() || cleanName;

  return (
    <Modal
      open={open}
      title="Duplicate form to another practitioner"
      okText={loading ? "Duplicating..." : "Duplicate"}
      okButtonProps={{ disabled: targetRoleIds.length === 0, loading }}
      onOk={() =>
        onConfirm({
          targetRoleIds,
          name: nextName,
        })
      }
      onCancel={onCancel}
      destroyOnClose
    >
      <Flex vertical gap={12}>
        <div>
          <Typography.Text type="secondary" style={{ fontSize: 12 }}>
            Source form
          </Typography.Text>
          <div>
            <Typography.Text strong>{form?.name}</Typography.Text>{" "}
            <Typography.Text type="secondary">
              from {sourceRole?.name}
            </Typography.Text>
          </div>
        </div>

        <div>
          <Typography.Text style={{ fontSize: 12 }}>
            Name in target role(s)
          </Typography.Text>
          <Input
            addonBefore={cleanName}
            value={nameSuffix}
            onChange={(e) => setNameSuffix(sanitizeSuffix(e.target.value))}
            placeholder="Suffix"
          />
          <Typography.Text type="secondary" style={{ fontSize: 12 }}>
            Will be saved as: <strong>{nextName}</strong>
          </Typography.Text>
        </div>

        <div>
          <Typography.Text style={{ fontSize: 12 }}>
            Target practitioner(s)
          </Typography.Text>
          <Select
            mode="multiple"
            value={targetRoleIds}
            onChange={setTargetRoleIds}
            options={options}
            placeholder="Select one or more roles"
            style={{ width: "100%" }}
          />
        </div>

        <Alert
          type="info"
          showIcon
          message="Sections, fields, and their configuration are copied. Submitted responses are not."
        />
      </Flex>
    </Modal>
  );
};

export default DuplicateFormModal;
